import { jsx as t } from "../../../_virtual/jsx-runtime.mjs";
import "../../../depend/rc-field-form/es/index.mjs";
import "react";
import "../../../depend/rc-util/es/hooks/useLayoutEffect.mjs";
import "../../../depend/rc-util/es/ref.mjs";
import { warningOnce as a } from "../../../depend/rc-util/es/warning.mjs";
import s from "../../../depend/rc-field-form/es/List.mjs";
const l = ({
  children: i,
  ...r
}) => (process.env.NODE_ENV !== "production" && a(
  typeof r.name == "number" || (Array.isArray(r.name) ? !!r.name.length : !!r.name),
  "Miss `name` prop."
), /* @__PURE__ */ t(s, { ...r, children: (m, o, n) => i(
  m.map((e) => ({ ...e, fieldKey: e.key })),
  o,
  {
    errors: n.errors,
    warnings: n.warnings
  }
) }));
export {
  l as default
};
//# sourceMappingURL=index.mjs.map
